<template>
    <input
        style="padding-left: 20px;"
        :type="type"
        class="form-control"
        :placeholder="placeholder"
        :value="value"
        @input="change($event.target.value)"
        @keyup.enter="searchInputTrigger"
    />  
</template>


<script>
    export default {
        props: {
            placeholder: String,
            value: String,
            type: String,
            searchInputTrigger: Function
        },
        methods: {
            change(val) {
                this.$emit('input', val)
            }
        }
    }
</script>

